import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { createSharedSubscription } from '@new/__global/utils/createSharedSubscription'

interface StayTimelineArgs {
  bookingId: string
  url: string
}

const buildSubscriptionKey = (bookingId: string) => `stay-timeline:${bookingId}`

const stayTimelineSubscription = createSharedSubscription({
  getKey: ({ bookingId }) => buildSubscriptionKey(bookingId),
  open: ({ bookingId, url }: StayTimelineArgs) => {
    return arriereBackoffice.subscriptions.stayTimelineChanged({
      __alias: 'stayTimelineChanged',
      __url: url,
      __args: { bookingId },
      bookingId: true,
      at: true,
    })
  },
  /** Two missed 15-second server heartbeats: only a connection that died without closing trips it. */
  idleTimeoutMs: 35_000,
})

export interface SubscribeToStayTimelineParams {
  bookingId: string
  url: string
  signal: AbortSignal
  onChange: () => void
  onLive: (isLive: boolean) => void
}

export const subscribeToStayTimeline = ({
  bookingId,
  url,
  signal,
  onChange,
  onLive,
}: SubscribeToStayTimelineParams) => {
  stayTimelineSubscription.subscribe({
    args: { bookingId, url },
    signal,
    onValue: change => {
      if (change.bookingId === bookingId) {
        onChange()
      }
    },
    onLive,
  })
}

export const isStayTimelineLive = (bookingId?: string) => {
  return !!bookingId && stayTimelineSubscription.isLive(buildSubscriptionKey(bookingId))
}
